import React, { useState, useEffect } from "react";
import CustomCarousel from "../../Components/Carousel";
import Header from "../../Components/Header";
import {
  Box,
  Stack,
  Button,
  Typography,
  useMediaQuery,
  Divider,
} from "@mui/material";
import { ServicesSteps } from "../../Data/index";
import Announcement from "../../Components/Main/Announcement";
import Hostels from "../../Components/Main/Hostels";
import News from "../../Components/Main/News";
import ServiceBgImg from "../../Icons/ServiceBgImg.svg";
import OurServices from "../../Components/Services/OurServices";
import { ReactComponent as Monitor } from "../../Icons/Services/Monitor.svg";
import { ReactComponent as TrustWorthy } from "../../Icons/Services/TrustWorthy.svg";
import { ReactComponent as OnlineSupport } from "../../Icons/Services/OnlineSupport.svg";
import ContactUs from "../../Components/Services/ContactUs";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export default function Services() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(min-width:600px) and (max-width:960px)");
  const { id } = useParams();
  const {t} = useTranslation()
  const data = useSelector((state) => state.AdminData.admin);
  console.log("id", id);
  const language = useSelector((state) => state.language.language);
  const styles = useSelector((state) => state.styles)
  const navigate = useNavigate();
  const [serviceData, setServiceData] = useState({});
  const [routhPath, setRoutePath] = useState(null);

  const fetchService = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}get-common-service-by-id/${id}`
      );
      console.log(response);
      if (response.status === 200) {
        setServiceData(response?.data?.data);
        setRoutePath(
          response?.data?.data?.title?.en
            ? String(response?.data?.data?.title?.en)
                .toLowerCase()
                .trim()
                .replace(/[\s-]+/g, "")
            : null
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getEmbedUrl = (url) => {
    if (!url) return "";
  
    // Handle full YouTube link
    if (url.includes("youtube.com/watch?v=")) {
      const videoId = new URL(url).searchParams.get("v");
      return `https://www.youtube.com/embed/${videoId}`;
    }
  
    // Handle shortened YouTube link
    if (url.includes("youtu.be/")) {
      const videoId = url.split("youtu.be/")[1];
      return `https://www.youtube.com/embed/${videoId}`;
    }
  
    // Return original for direct video files
    return url;
  };


  function isYouTubeUrl(url) {
    const regex = /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)[\w-]{11}(&.*)?$/;
    return regex.test(url);
  }

  useEffect(() => {
    fetchService();
  }, [id]);
  console.log("routePath", routhPath);
  return (
    <>
      

      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Box sx={{ width: { xs: "95%", lg: "90%" } }}>
          <Box sx={{ mt: { xs: "20px", lg: "60px" } }}>
            <Typography
              sx={{
                ...styles.h3,
                color: "rgba(0, 126, 202, 1)",
              }}
            >
              {serviceData?.title?.[language]}
            </Typography>
          </Box>

          <Box sx={{ mt: { xs: "25px", lg: "50px" } }}>
            <Box
              
              sx={{ 
                width: "100%", 
                borderRadius: "24px",
                height : '400px',
                overflow: "hidden",
              backgroundImage : `url(${process.env.REACT_APP_FILE_PATH + serviceData?.img?.filename})`,
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover", 
              }}
            ></Box>
          </Box>

          <Box sx={{ mt: { xs: "25px", lg: "48px" } }}>
            <Typography
              sx={{
                color: "rgba(67, 67, 67, 1)",
                ...styles.h2
              }}
            >
              {serviceData?.heading1?.[language]}
            </Typography>
          </Box>

          <Box sx={{ mt: "16px" }}>
            <Typography sx={{ ...styles.subheadingDescription }}>
              {serviceData?.description1?.[language]}
            </Typography>
          </Box>

          <Box sx={{ mt: { xs: "20px", lg: "26px" } }}>
            <Typography
              sx={{
                color: "rgba(67, 67, 67, 1)",
                ...styles.h2
              }}
            >
              {serviceData?.heading2?.[language]}
            </Typography>
          </Box>

          <Box sx={{ mt: "16px" }}>
            <Box
              sx={{ ...styles.subheadingDescription }}
              dangerouslySetInnerHTML={{
                __html: serviceData?.description2?.[language] || "",
              }}
            />
          </Box>

          <Box sx={{ mt: "26px" }}>
            <Divider />
          </Box>

          {serviceData?.images?.length > 0 && (
            <Box sx={{ mt: { xs: "20px", lg: "26px" } }}>
              <Typography
                sx={{
                  color: "rgba(67, 67, 67, 1)",
                  ...styles.h2
                }}
              >
                {t("Photos")}
              </Typography>

              <Box
                sx={{ display: "flex", flexDirection: "column", gap: 4, mt: '50px' }}
              >
                {serviceData?.images.map((img) => (
                  <Box
                    sx={{ 
                      
                      borderRadius: "8px" ,
                      height : '400px',
                      overflow: "hidden",
                      backgroundImage : `url(${process.env.REACT_APP_FILE_PATH + img?.filename})`,
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover", 
                    }}
                  />
                ))}
              </Box>
            </Box>
          )}

          {serviceData?.videoUrls?.length > 0 && serviceData?.videoUrls[0]?.url?.length > 0 && (
            <Box sx={{ mt: { xs: "20px", lg: "60px" } }}>
              <Typography
                sx={{
                  color: "rgba(67, 67, 67, 1)",
                  ...styles.h2
                }}
              >
                {t("Videos")}
              </Typography>

              <Box
                sx={{ display: "flex", flexDirection: "column", gap: 4, mt: '50px', mb : '50px' }}
              >
                {serviceData?.videoUrls.map((vid, index) => (
                  <>
                  {isYouTubeUrl(vid?.url) && ( 
                  <Box
                    key={index}
                    sx={{ borderRadius: "8px", overflow: "hidden" }}
                  >
                    <iframe
                    width="100%"
                    height="400px"
                    src={getEmbedUrl(vid?.url)}
                    title={`Video ${index + 1}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                  </Box>
                  )}
                  </>
                ))}
              </Box>
            </Box>
          )}

          {serviceData?.showButton === true && routhPath && (
            <Box sx={{ mt: "26px" }}>
              <Button
                onClick={() => {
                  if(data?.id){
                    navigate(`/services/${routhPath}/${id}`)
                  }else{
                    navigate('/login')
                  }
                }}
                sx={{
                  
                  ":hover": {
                    backgroundColor: "rgba(26, 36, 97, 1)",
                    color: "white",
                  },
                  backgroundColor: "rgba(26, 36, 97, 1)",
                  color: "white",
                  ...styles.button,
                  borderRadius: "10px",
                  width : '200px'
                }}
              >
                {t("Book Service")}
              </Button>
            </Box>
          )}

          <Box sx={{ mt: "53px" }}></Box>
        </Box>
      </Box>
    </>
  );
}
